module.exports = __webpack_public_path__ + "img/1.3d8d1120.png";